import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const parentingTired: BlogMetaData = {
  title: '子育て疲れた…は当然｜育児疲れたときに今日からできる7つの対処法',
  description:
    '「子育て疲れた」「育児疲れた」と感じるのは当然。睡眠不足・孤独・イヤイヤ期…原因別の対処法と、モンテッソーリ流「引き算の育て方」を解説します。',
  thumbnailUrl: '/img/blog-parenting-tired.webp',
  filePath: buildBlogFilePath('parenting-tired'),
  category: BLOG_CATEGORY.PARENTING,
};
